function toggleReadMore(id) {
    var content = document.getElementById(id);
    var link = content.nextElementSibling;
    if (content.classList.contains('collapsed')) {
        content.classList.remove('collapsed');
        content.classList.add('expanded');
        link.textContent = 'Lire moins';
    } else {
        content.classList.remove('expanded');
        content.classList.add('collapsed');
        link.textContent = 'Lire plus';
    }
}